import { get } from '../tools/http';
import Vue from 'vue';
import { getImgUrl } from '../tools/uploader';
import placeHolder from '../assets/images/account/placeHolder-m.png';

export default {
    namespaced: true,
    state: {
        clusters: [],
        competence: {},
        softCompetences: [],
        hardCompetences: [],
        competenceList: [],
        competencePrograms: [],
        competenceProgramsTotal: null,
        userCompetences: [],
        userCompetencesTotal: null,
    },
    mutations: {
        setCompetencesByType(state, {type, items}) {
            state[`${type}Competences`] = items;
        },
        setCompetencesTypes: (state, clusters) => {
            state.clusters = clusters;
            state.clusters.forEach(async (cluster) => {
                cluster.image = await getImgUrl(cluster.image, placeHolder);
            });
        },
        setCompetenciesByClusterId: (state, { competences, clusterId }) => {
            let clusterFinder = state.clusters.find((cluster) => {
                return cluster.id == clusterId;
            });
            if (clusterFinder) {
                competences.forEach(async (competence) => {
                    competence.image = await getImgUrl(competence.image, placeHolder);
                });
                Vue.set(clusterFinder, 'competences', competences);
            }
        },
        setCompetence: (state, competence) => {
            state.competence = competence;
        },
        setCompetenceList: (state, competences) => {
            state.competenceList = competences;
        },
        setCompetencePrograms: (state, programs) => {
            state.competencePrograms = programs;
        },
        setCompetenceProgramsTotal: (state, programsTotal) => {
            state.competenceProgramsTotal = programsTotal;
        },
        setUserCompetences: (state, competences) => {
            state.userCompetences = competences;
        },
        setUserCompetencesTotal: (state, competencesTotal) => {
            state.userCompetencesTotal = competencesTotal;
        },
    },
    actions: {
        async loadCompetencesByType({commit}, {type, params = {}}) {
            const answer = await get('progress', 'api/v1/competence', params);
            commit('setCompetencesByType', {type, items: answer});
        },
        loadCompetencesClusters: async (ctx) => {
            const response = await get('progress', 'api/v1/cluster');
            ctx.commit('setCompetencesTypes', response);
        },
        loadCompetenciesByClusterId: async (ctx, id) => {
            const requestParams = [
                'progress',
                `api/v1/competence/byCluster/${id}`,
            ];
            const response = await get(...requestParams);

            const commitParams = [
                'setCompetenciesByClusterId',
                {
                    competences: response.filter((comp)=>comp.isPublish),
                    clusterId: id,
                },
            ];
            ctx.commit(...commitParams);
        },
        loadCompetenceById: async (ctx, id) => {
            let competence = {};
            ctx.commit('setCompetence', competence);
            const requestParams = [
                'progress',
                `api/v1/competence/select/${id}`,
            ];
            competence = await get(...requestParams);
            ctx.commit('setCompetence', competence);
            return competence;
        },
        loadCompetenceList: async (ctx) => {
            const requestParams = [
                'progress',
                `api/v1/competence`,
            ];
            let competences = await get(...requestParams);
            ctx.commit('setCompetenceList', competences ? competences.filter((comp)=>comp.isPublish) : null);
        },
        async loadCompetencePrograms(ctx, { competenceId, limit, offset, filter = {} }) {
            try {
                const filterString = {};
                Object.keys(filter).forEach((key) => {
                    if (
                        key === 'durationInterval'
                        && filter.durationInterval
                    ) {
                        filterString['filter[durationInterval][min]'] = filter.durationInterval.min;
                        filterString['filter[durationInterval][max]'] = filter.durationInterval.max;
                    } else if (
                        key === 'costOfStudy'
                        && filter.costOfStudy
                    ) {
                        if (filter.costOfStudy.min !== '') {
                            filterString['filter[costOfStudy][min]'] = filter.costOfStudy.min;
                        }
                        if (filter.costOfStudy.max !== '') {
                            filterString['filter[costOfStudy][max]'] = filter.costOfStudy.max;
                        }
                        filterString['filter[costOfStudy][isFree]'] = filter.costOfStudy.isFree;
                    } else {
                        filterString[`filter[${key}]`] = filter[key];
                    }
                });
                const { items, total } = await get('progress', `api/v2/competences/${competenceId}/programs:viewSearchStudy`, {
                    limit,
                    offset,
                    ...filterString,
                });
                ctx.commit('setCompetencePrograms', items && items.length ? items : []);
                ctx.commit('setCompetenceProgramsTotal', total ? total : 0);
            } catch (e) {
                console.error(e);
            }
        },
        async loadUserCompetences(ctx) {
            try {
                const { items, total } = await get('progress', `api/v2/user/competences`);
                if (!items || !items.length) {
                    return null;
                }
                ctx.commit('setUserCompetences', items && items.length ? items : []);
                ctx.commit('setUserCompetencesTotal', total ? total : 0);
            } catch (e) {
                console.error(e);
            }
        },
    },
    getters: {
        getCompetencesClusters: state => state.clusters,
        getCompetence: state => state.competence,
        getSoftCompetences: state => state.softCompetences,
        getHardCompetences: state => state.hardCompetences,
        getCompetenceById: state => id => {
            return state.competenceList.find((competence) => {
                return competence.id == id;
            });
        },
        getCompetencePrograms: state => state.competencePrograms,
        getCompetenceProgramsTotal: state => state.competenceProgramsTotal,
        getUserCompetences: state => state.userCompetences,
        getUserCompetencesTotal: state => state.userCompetencesTotal,
    },
};
